import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import { CreateChancel, SelectAutocompletePagination } from 'components';
import { httpRequestsOnSuccessActions, taskActions } from 'store';
import { FindLoad, useModal, FindSuccessItem, renderStaffName, staffStatusEnums } from 'utils';

const ACTION_TYPE = 'BULK_ASSIGN_TASK';

export const ChangeTaskAssigned = ({ selectedIds, afterSuccess, renderParams }) => {
    const { watch, handleSubmit, control, reset } = useForm();
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();

    useEffect(() => {
        if (success) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            close();
            afterSuccess();
        }
    }, [success]);

    const handleCreate = (data) => {
        dispatch(taskActions.bulkAssignTask({ ids: selectedIds, assignee: data?.assignee }, renderParams));
    };

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">Assign Tasks</p>
            <p className="modal-header-sub">{`Assign ${selectedIds?.length} selected tasks to a team member.`}</p>
            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <Controller
                        name="assignee"
                        control={control}
                        rules={{ required: 'Assignee is required.' }}
                        render={({ field, fieldState: { error } }) => {
                            return (
                                <SelectAutocompletePagination
                                    defaultStatuses={[staffStatusEnums.ACTIVE]}
                                    title={'Assignee*'}
                                    name="assignee"
                                    handleSelect={(e) => {
                                        field.onChange(e?.target?.value ? e?.target?.value : null);
                                    }}
                                    defaultValue={field.value}
                                    renderValue={(i) => renderStaffName(i) || i?.name}
                                    type="staff"
                                    error={error?.ref?.name}
                                    typeError={error?.message}
                                />
                            );
                        }}
                    />
                </div>
                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Assign Tasks'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'24px'}
                />
            </form>
        </div>
    );
};
